import { render, staticRenderFns } from "./PlainDropdownPlayground.vue?vue&type=template&id=ec4f3220&scoped=true&"
import script from "./PlainDropdownPlayground.vue?vue&type=script&lang=js&"
export * from "./PlainDropdownPlayground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4f3220",
  null
  
)

export default component.exports